<script>
export default {
    props: {
        field: {
            type: Object,
            required: true,
        },
        value: {
            type: String,
            default: null,
        },
    },
    computed: {
        isImage() {
            return this.value?.toLowerCase().match(/\.(jpeg|jpg|gif|png|webp)$/) != null;
        },
    },
};
</script>

<template>
    <div>
        <a
            v-if="value"
            :href="value"
            target="_blank"
        >
            <img
                v-if="isImage"
                :src="value"
                :alt="field.label"
                class="img-responsive"
            >
            <span v-else>
                {{ field.label ?? value }}
                <i class="fas fa-external-link-alt" />
            </span>
        </a>
    </div>
</template>

<style
    scoped
    lang="scss"
>

</style>
